<template>
  <div class="success-ordered-message">
    <div class="background" :style="image">
      <router-link to="/orders" replace>
        <BackstageIcon name="close" class="btn-close" data-cy="popup-close-button" />
      </router-link>
      <div class="popup-container" data-cy="success-order-popup">
        <BackstageIcon name="success" class="icon" data-cy="success-icon" />
        <div>
          <h4 class="title" data-cy="success-title">
            {{ successTitle }}
          </h4>
        </div>
        <p class="info" data-cy="success-message">
          {{ successMessage }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackstageIcon from '@/components/common/BackstageIcon.vue';
import { useUserStore } from '../stores/user';

export default defineComponent({
  name: 'success-ordered-message',
  components: {
    BackstageIcon,
  },
  props: {
    orderNumber: String,
    orderType: String,
  },
  setup() {
    const { userProfile } = useUserStore();

    return {
      email: userProfile.profile?.email,
    };
  },
  data() {
    return {
      image: {
        backgroundImage: `url(${this.$t('successOrderedMessage.image_url')})`,
      },
    };
  },
  computed: {
    successTitle(): string {
      return this.isDraftOrderNumber()
        ? `${this.$t(`viewOrders.order_type["${this.orderType?.toLowerCase()}"]`)} ${this.$t(
            'successOrderedMessage.submitted',
          )}.`
        : `${this.$t(`viewOrders.order_type["${this.orderType?.toLowerCase()}"]`)} ${
            this.orderNumber
          } ${this.$t('successOrderedMessage.submitted')}.`;
    },
    successMessage(): string {
      return this.isDraftOrderNumber()
        ? `${this.$t('successOrderedMessage.will_receive')} ${this.email}. ${this.$t(
            'successOrderedMessage.track_order',
          )}.`
        : `${this.$t('successOrderedMessage.update_success_message')}`;
    },
  },
  methods: {
    isDraftOrderNumber() {
      return this.orderNumber?.includes('DRAFT');
    },
  },
});
</script>

<style lang="scss" scoped>
.success-ordered-message {
  max-width: 87.5rem;
  margin: 0 auto;
  width: 100%;
  height: fit-content;

  .background {
    position: relative;
    top: 0;
    background-position: top center;
    background-size: cover;
    background-repeat: no-repeat;
    height: 40.375rem;
    .popup-container {
      position: relative;
      top: 28%;
      max-width: 25.3125rem;
      height: fit-content;
      margin: auto;
      background-color: var(--primary-bg-color);
      border-radius: 0.25rem;
      padding: 2rem 1.25rem;

      .icon {
        width: 3rem;
        height: 3rem;
        margin: auto;
      }

      .title {
        margin: 2.5rem 0 0.25rem;
        font-weight: 500;
        font-size: 1.25rem;
        line-height: 150%;
      }

      .info {
        margin: 0;
        font-weight: 400;
        font-size: 1rem;
        line-height: 150%;
        color: var(--primary-text-remark-color);
        width: 80%;
        margin: auto;
      }
    }
    .btn-close {
      position: absolute;
      width: 2.625rem;
      height: 2.625rem;
      top: 1rem;
      right: 1rem;
      opacity: 1;
      background-color: var(--primary-bg-color);
      border-radius: 50%;

      &:hover {
        background-color: var(--primary-bg-color);
      }
      &:before,
      &:after {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        content: ' ';
        height: 1.125rem;
        width: 0.0625rem;
        background-color: var(--secondary-bg-color);
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
